









import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GEmptyNotation',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    buttonText: {
      type: String as PropType<string>,
      default: '新規作成',
    },
    size: {
      type: String as PropType<string>,
      default: 'small',
    },
    onClick: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
});
